export const DEFAULT_RETRY_POLICY = {
  maxAttempts: 3,
  initialDelayMs: 500,
  maxDelayMs: 5000,
  backoffStrategy: "exponential",
  timeoutMs: 30000,
};

/** Export workflows inherit the platform default. */
export const DEFAULT_EXPORT_RETRY_POLICY = DEFAULT_RETRY_POLICY;

/** AI generation API calls — longer timeout for model latency + backend retries. */
export const DEFAULT_GENERATION_RETRY_POLICY = {
  maxAttempts: 1,
  initialDelayMs: 750,
  maxDelayMs: 8000,
  backoffStrategy: "exponential",
  timeoutMs: 7200000,
};

/** Lightweight suggestion calls (familiar topics, etc.). */
export const DEFAULT_SUGGESTION_RETRY_POLICY = {
  maxAttempts: 2,
  initialDelayMs: 300,
  maxDelayMs: 1500,
  backoffStrategy: "exponential",
  timeoutMs: 30000,
};

export const RETRY_STATUS_MESSAGE = (attempt, maxAttempts, label = "Request") =>
  `Retrying ${label} (attempt ${attempt} of ${maxAttempts})…`;

export const EXPORT_RETRY_STATUS_MESSAGE = (attempt, maxAttempts) =>
  RETRY_STATUS_MESSAGE(attempt, maxAttempts, "export");

export const GENERATION_RETRY_STATUS_MESSAGE = (attempt, maxAttempts) =>
  RETRY_STATUS_MESSAGE(attempt, maxAttempts, "generation");
